import { atom } from 'jotai';

import { Referrer } from '../../utils/types/referrer';

export const customerReferrer = atom<Referrer>({
  id: 0,
  opted_in_at: null,
  finix_identity: null,
  finix_instrument: null,
  finix_verify: null,
  finix_merchant: null,
  instrument_type: null,
  instrument_brand: null,
  instrument_last_four: null,
  instrument_exp_mo: null,
  instrument_exp_yr: null,
  code: '',
});
